<template>
  <div>
    <p class="dialog-input-label my-0">{{ label }}</p>
    <v-tooltip v-model="error" left>
      <template v-slot:activator="{ attrs }">
        <v-file-input
          :placeholder="placeholder"
          :value="value"
          :rules="rules"
          :class="error ? 'validation-error' : ''"
          :readonly="readonly ? true : false"
          :accept="accept"
          height="48"
          dense
          solo
          flat
          hide-details
          full-width
          ref="file"
          prepend-icon=""
          prepend-inner-icon="bhi-upload"
          @click:prepend-inner="$refs.file.$el.querySelector('input').click()"
          @change="change"
        >
        </v-file-input>
        <span class="" v-bind="attrs"></span>
      </template>
      <span>This field value is invalid</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { FILE_SIZE_LIMIT, FILE_SIZE_LIMIT_NAME } from '@/helpers/constants'

export default {
  name: 'DialogFileInput',
  data: () => ({
    error: false,
  }),
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    prependIcon: {
      type: String,
      default: undefined,
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    validate: {
      type: Boolean,
      default: false,
    },
    validationType: {
      type: String,
      default: 'required',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Boolean, Number],
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapMutations('appStates', ['setSnackbarNotification']),
    validateMethod(value) {
      if (this.validate) {
        this.error = false
        this.newValue = value
      }
    },
    change(file) {
      if (!file || file.size <= FILE_SIZE_LIMIT) {
        this.$emit('change', file)
      } else {
        this.setSnackbarNotification(
          `Max upload file size is ${FILE_SIZE_LIMIT_NAME}. Try again with smaller file.`,
        )
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.dialog-input {
  &-label {
    color: $bh-gray--2;
  }
}
.v-input--is-readonly {
  .v-input__slot {
    background-color: $bh-blue--4 !important;
  }
}
.v-input.validation-error .v-input__slot {
  background-color: $bh-red !important;
  border-color: $bh-red !important;
}
</style>
